import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './custom.css'
import { useDispatch } from 'react-redux';
import { parseConnection } from '../src/store/Actions';
import { parseNotification } from '../src/store/Actions';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import Signal from '../src/components/actions/Signal';
import Cookies from 'js-cookie';
import Spinner from './components/Reusables/Spinner';

import Brands from './components/pages/Brands';
import Contacts from './components/pages/Contacts';
import Entities from './components/pages/Entities';
import Projects from './components/pages/Projects';
import ProjectsNew from './components/pages/ProjectsNew';
import Updates from './components/pages/Updates';
import Websites from './components/pages/Websites';
import ProjectDetails from './components/pages/ProjectDetails';
import CreateNew from './components/pages/CreateNew';
import CreateNewcontact from './components/pages/NewContact';
import EditProject from './components/pages/EditProject';
import ContactsInfo from './components/pages/ContactsInfo';
import EditCreateTask from './components/pages/EditCreateTask';
import Profile from './components/pages/Profile';
import Login from './components/pages/Login';
import Homepage from './components/pages/Homepage';
import ProjectReports from './components/pages/ProjectReports'
import Users from './components/pages/Users';
import CreateNewUser from './components/pages/CreateNewUser';
import Roles from './components/pages/Roles';
import AddWebsite from './components/pages/AddWebsite';
import Notification from './components/pages/Notification';
import Broadcast from './components/pages/Broadcast';
import Preview from './components/pages/Preview';
import BroadcastFiles from './components/pages/BroadcastFiles';
import ResetPassword from './components/pages/ResetPassword';
import ForgotPassword from './components/pages/ForgotPassword';
import Resources from './components/pages/Resources';
import POC from './components/pages/POC';


function App() {
  // static displayName = App.name;
    const SIGNALR_URL = Signal();
    const dispatch = useDispatch();
    const loader = document.getElementById('initial-loader');

    if (loader && !loader.hasAttribute('hidden')) {
      loader.setAttribute('hidden', 'true');
    }


    const access_token = Cookies.get('access_token');
    
    //SignalR
    const newConnection = new HubConnectionBuilder()
        .withUrl(`${SIGNALR_URL}/uploadchat`, {
         accessTokenFactory: () => access_token,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
    })
    .withAutomaticReconnect()
    .build();
    dispatch(parseConnection(newConnection));
    console.log("[LoginSignalRlogin]", newConnection);

     // Receiving the response
    newConnection.on("Notification", function (user, message) {
      // We can assign user-supplied strings to an element's textContent because it
      // is not interpreted as markup. If you're assigning in any other way, you 
      // should be aware of possible script injection concerns.
      console.log("[LoginSignalR] RECEIVING... ", user, message)
      dispatch(parseNotification(message));
    });

    // Connection start
    newConnection.start().then(function () {
        console.log("[LoginSignalR] Receiving ...");
    }).catch(function (err) {
        return console.error(err.toString());
    });

    return (
      <Routes>
        <Route exact path='/' element={<Homepage />}/>
        <Route path='/projects/list' element={<Projects />}/>
        <Route path='/projects/:project_type/list' element={<Projects />}/>
        <Route path='/projects/new' element={<ProjectsNew />}/>
        <Route path='/projects/:id/view' element={<ProjectDetails />}/>
        <Route path='/projects/:id/edit' element={<EditProject />}/>
        <Route path='/projects/:id/task/:taskid/edit' element={<EditCreateTask />}/>
        <Route path='/projects/:id/task/new' element={<EditCreateTask />}/>
        <Route path='/projects/reports/list' element={<ProjectReports />} />
        <Route path='/projects/:project_type/reports/list' element={<ProjectReports />} />
        <Route path='/portals/list' element={<Brands />}/>
        <Route path='/portals/new' element={<CreateNew />}/>
        <Route path='/portals/:id/edit' element={<CreateNew />}/>
        <Route path='/portals/:id/view' element={<CreateNew />}/>
        <Route path='/properties/list' element={<Entities />}/>
        <Route path='/properties/new' element={<CreateNew />}/>
        <Route path='/properties/:id/edit' element={<CreateNew />}/>
        <Route path='/properties/:id/view' element={<CreateNew />}/>
        <Route path='/contacts/list' element={<Contacts />}/>
        <Route path='/contacts/new' element={<CreateNewcontact />}/>
        <Route path='/contacts/:id/view' element={<ContactsInfo />}/>
        <Route path='/contacts/:id/edit' element={<CreateNewcontact />}/>
        <Route path='/websites/list' element={<Websites />}/>
        <Route path='/websites/new' element={<AddWebsite />}/>
        <Route path='/websites/:id/edit' element={<AddWebsite />}/>
        <Route path='/updates' element={<Updates />}/>
        <Route path='/notification' element={<Notification />}/>
        <Route path='/profile' element={<Profile />}/>
        <Route path='/profile/:id/edit' element={<Profile />}/>
        <Route path='/users/list' element={<Users />}/>
        <Route path='/users/new' element={<CreateNewUser />}/>
        <Route path='/users/:id/edit' element={<CreateNewUser />}/>
        <Route path='/users/:id/view' element={<CreateNewUser />}/>
        <Route path='/roles' element={<Roles />}/>
        <Route path='/login' element={<Login />}/>
        <Route path='/projects/:id/broadcast' element={<Broadcast />}/>
        <Route path='broadcast/draft/:name/:id' element={<Preview />}/>
        <Route path='broadcast/:brand/:project/:projectname/:id' element={<Preview />}/>
        <Route path='/projects/:id/broadcast/files' element={<BroadcastFiles />}/>
        <Route exact path='/reset-password' element={<ResetPassword />} />
        <Route exact path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/cc-resources' element={<Resources />}/>
        <Route path='/poc/:year/:title' element={<POC/>}/>
      </Routes>
    );
} 
export default App;
